import * as THREE from 'three';
import { useEffect, useRef } from "react";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import './MyThree.css';


function MyThree() {
  const refContainer = useRef(null);
  useEffect(() => {
    // === THREE.JS CODE START ===
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(15, window.innerWidth / window.innerHeight, 0.1, 1000);
    var renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    // document.body.appendChild( renderer.domElement );
    // use ref as a mount point of the Three.js scene instead of the document.body
    refContainer.current && refContainer.current.appendChild( renderer.domElement );
    const planettex = new THREE.TextureLoader().load('https://upload.wikimedia.org/wikipedia/commons/4/46/Solarsystemscope_texture_2k_mars.jpg');

    function initPoints() {
  
        const geometry = new THREE.BufferGeometry();
        var positions = [];
        
        for (var i = 0; i < 20000; i ++ ) {
            const [x] = Array(1).fill().map(() => THREE.MathUtils.randFloatSpread(100));
            const y = THREE.MathUtils.randFloat(-10, 11);
            const z = THREE.MathUtils.randFloat(-11, 0);
            positions.push( x, y, z );
        }
        
        geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( positions, 3 ) );
        
        const material = new THREE.PointsMaterial( { 
            color: 0xffffff, 
            size: 0.1,
         } );

        const particles = new THREE.Points(geometry, material);
        scene.add( particles );
    }

    initPoints();
    
    const planet = new THREE.Mesh(
        new THREE.IcosahedronGeometry(8,27),
        new THREE.MeshStandardMaterial( {
            color: 0xFFFFFF,
            map: planettex,
            wireframe: false,
        } )
    );
    scene.add(planet);

    const loader = new GLTFLoader();
    loader.load( '../assets/astroman.glb', function ( gltf ) {
      scene.add( gltf.scene );
    } );

    const ambient = new THREE.AmbientLight(0xFF3333,3);
    scene.add(ambient);
    camera.position.z = 8;
    camera.position.y = 7.51;
    planet.rotation.z = 3;

    function moveCamera() {
        const t = document.body.getBoundingClientRect().top;
        camera.position.z = 8 + t * -0.048;
        camera.position.y = 7.51 + t * 0.006;
    }

    document.body.onscroll = moveCamera;

    var animate = function () {
      requestAnimationFrame(animate);
      planet.rotation.x -= 0.001;
      renderer.render(scene, camera);
    };
    animate();
  }, []);
  return (
    <div ref={refContainer} className='stuff'></div>
  );
}

export default MyThree
